import type { IconProps } from '../types/IconProps.ts';
export const ListFilter: IconProps = {
    name: 'ListFilter',
    children: [
        `<path d="M2 5h20M6 12h12M10 19h4" />`,
    ]
};